import * as yup from 'yup'

import constants from 'constants/index'

const { EVIDENCE_FILE_TYPES, EVIDENCE_FILE_MIMES_TYPES } = constants.planAction

const schema = yup.object().shape({
  what: yup.string().required('Preencha esse campo'),
  how: yup.string(),
  because: yup.string(),
  where: yup.string(),
  howPrice: yup.string(),
  link: yup.string(),
  startDate: yup
    .date()
    .notInPast({ message: 'A data não pode estar no passado' })
    .required('Preencha a data de início')
    .typeError('Preencha a data de início'),
  deadlineDate: yup
    .date()
    .notInPast({ message: 'A data não pode estar no passado' })
    .required('Preencha o prazo final')
    .typeError('Preencha o prazo final'),
  responsibleUserId: yup
    .number()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' ? null : value)),
  justify: yup.string().max(5000),
  evidences: yup.mixed().fileUpload({
    types: EVIDENCE_FILE_TYPES,
    mimeTypes: EVIDENCE_FILE_MIMES_TYPES,
    sizeMessage: 'O documento deve ter no máximo 10 MB',
  }),
})

export default schema
